import ButtonRaw from '@/components/Button/ButtonRaw';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import type {ButtonModel} from '@/types/aem';

type AutoDeliveryDcxWidgetHeaderButtonProps = {
    button?: ButtonModel;
    onClick?: () => void;
};

const AutoDeliveryDcxWidgetHeaderButton = ({button, onClick}: AutoDeliveryDcxWidgetHeaderButtonProps) => {
    const {redirectToExternalLink} = useConfigExternalLink(button?.externalLink);

    if (!button) return null;
    if (!button.externalLink && !onClick) return null;

    const handleClick = () => {
        if (onClick) {
            onClick();
            return;
        }
        redirectToExternalLink?.();
    };

    return (
        // @ts-expect-error
        <ButtonRaw
            className='flex shrink-0 gap-2 border-primary-dark-85 py-3 tracking-05'
            onClick={handleClick}
            aria-label={button.alt}
        >
            <span className='flex-1 ml:leading-15'>{button.text}</span>
            {button.icon && <RemoteIconV2 icon={button.icon} className='size-6' />}
        </ButtonRaw>
    );
};

export default AutoDeliveryDcxWidgetHeaderButton;
